module.exports = __webpack_public_path__ + "media/post-listing-cross-promotoe-ico-3@2x.5e17f227.png";